export function makeDataTestIdGetter(prefix) {
    return (id) => {
        return prefix ? `${prefix}-${id}` : id;
    };
}
